export const closeTopicViewer = viewer => ({
  type: "CLOSE_TOPIC_VIEWER",
  viewer
});

export const openTopicViewer = viewer => ({
  type: "OPEN_TOPIC_VIEWER",
  viewer
});

export const setCurrentTopic = media => ({
  type: "SET_CURRENT_TOPIC_VIEWER",
  media: media
});

export const fetchSingleTopic = resp => {
  return {
    type: "FETCH_SINGLE_TOPIC",
    payload: resp
  };
};
/*export const saveTopicComment = resp => ({
  type: "SAVE_TOPIC_COMMENT",
  payload: resp
});*/



// WEBPACK FOOTER //
// ./src/actions/actions/topic-viewer.js